import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";



export const fetchTaxes = async (params = {}) => {
  // If you want, you can pass id and action in params, or separate params for flexibility
  const { id = null, action = null, searchParams, selectedFilterOption, selectedSortOption } = params;

  if (id) {
    const response = await authenticatedAxios.get(`${baseurl}tax/?id=${id}`);
    return response.data;
  } else {
    const queryParams = {
      search: searchParams?.term,
      search_argument: searchParams?.argument,
      filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
      sort: selectedSortOption,  
    };
    const response = await authenticatedAxios.get(`${baseurl}tax/`, { params: queryParams });
    return response.data;
  }
};

export const addTax = async (formValues) => {
  const response = await authenticatedAxios.post(`${baseurl}tax/`, formValues);
  return response.data;
};

export const editTax = async (id, formValues) => {
  const response = await authenticatedAxios.put(`${baseurl}tax/?id=${id}`, formValues, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteTax = async (id) => {
  const response = await authenticatedAxios.delete(`${baseurl}tax/?id=${id}`);
  return response;
};

export const archiveSelectedTaxes = async (idList) => {
  const response = await authenticatedAxios.post(`${baseurl}tax/archive/`, { id_list: idList });
  return response;
};


export const archiveTax = async (id) => {
  const response = await authenticatedAxios.get(`${baseurl}tax/archive/?id=${id}`);
  return response;
};
